module.exports = __webpack_public_path__ + "img/talent_management_banner.3db0080b.jpg";